import Backbone from 'backbone';
import _ from 'underscore';
import { a11yPlugin } from '@bingads-webui/projection-grid-a11y';
import projectionGrid from 'projection-grid';

import { generateConfig } from './import-summary-grid-config';

function setGridExpandBehavior(expand, e) {
  const { gridView } = this.grid;
  const index = gridView.indexOfElement(e.target);
  const key = gridView.keyOfElement(e.target);
  const entity = gridView.itemWithKey(key);
  const dataSource = gridView.get('dataSource');

  dataSource.data[index].Expanded = expand;
  if (expand) {
    dataSource.data.splice(index + 1, 0, entity.Children);
    dataSource.data = _.flatten(dataSource.data, true);
  } else {
    dataSource.data = _.reject(dataSource.data, elem => _.findWhere(entity.Children, elem));
  }
  gridView.set({
    dataSource,
  });
}

export class ImportSummaryGridView extends Backbone.View {
  initialize({
    data,
    i18n,
  }) {
    const config = generateConfig({
      data,
      i18n,
    });

    this.grid = projectionGrid
      .factory({
        vnext: true,
      })
      .use(a11yPlugin)
      .create(_.extend({}, config, {
        events: {
          'click .expanderImage': _.partial(setGridExpandBehavior, true).bind(this),
          'click .expandedImage': _.partial(setGridExpandBehavior, false).bind(this),
        },
      }));

    this.grid.gridView.on('willUpdate', () => {
      this.$el.addClass('fixed-height');
    }, this);

    this.grid.gridView.on('didUpdate', () => {
      this.$el.removeClass('fixed-height');
      // fix accessibility issue, make the grid scrollable by keyboard
      this.$el.find('.table-container .viewport').attr('tabindex', 0);
    }, this);
  }

  render() {
    this.$el.html(this.grid.gridView.render().el);
    return this;
  }

  remove() {
    this.grid.gridView.remove();
    this.grid = null;
    super.remove();
  }
}
